import { useField } from 'react-final-form';

import { WorkloadDetailsFormModel, Path } from '../_types';

export const useDisabledResource = (type: 'cpu' | 'memory') => {
  const cpuPath: Path<WorkloadDetailsFormModel> =
    'verticalRightsizing.policy.optimizedResources.cpu';

  const memoryPath: Path<WorkloadDetailsFormModel> =
    'verticalRightsizing.policy.optimizedResources.memory';

  const field = useField<boolean>(type === 'cpu' ? cpuPath : memoryPath);

  return !field.input.value;
};
